<template lang="pug">
    div
        table.table-auto.border-collapse.border.border-slate-400.w-full.bg-white
            table-header(:list="USERS_LIST_TABLE_HEADERS")
            tbody
                template(v-for="(item, index) in users")
                    tr(:key="item._id" :class="{'bg-yellow-100': item._id === user_id}")
                        td.border.border-gray-300.w-10.font-light.text-xs.text-center
                            span {{ rowNumber(index) }}
                        td.border.border-gray-300.p-2(style="width: 80px; min-width: 80px;")
                            user-image(:item="item" :isActive="permissionsInit({item})")                            
                        td.text-sm.font-thin.border.border-gray-300.text-center.p-1
                            user-field(:item="item" field="firstname" :isActive="permissionsInit({item})")
                        td.text-sm.font-thin.border.border-gray-300.text-center.p-1
                            user-field(:item="item" field="lastname" :isActive="permissionsInit({item})")
                        td.text-sm.font-thin.border.border-gray-300.text-center.p-1
                            user-field(:item="item" field="patronymic" :isActive="permissionsInit({item})")
                        td.text-sm.font-thin.border.border-gray-300.text-center.p-1.w-250
                            span {{ item.email }}
                        td.text-sm.font-thin.border.border-gray-300.text-center.p-1.w-200
                            user-field(:item="item" field="phone" :isActive="permissionsInit({item})" placeholder="В формате 79781234567")
                        
                        //- Роли
                        td.p-4.text-sm.font-thin.border.border-gray-300.text-center.p-1.w-150    
                            template(v-if="onPermissions({item}) && item.role !== 1")
                                user-select(:item="item" field="role")
                            template(v-else)
                                span {{ ROLES.find(r => { return r.value === item.role }).name }}
                        
                        //- Группы
                        td.p-4.text-sm.font-thin.border.border-gray-300.text-center.p-1.w-150   
                            template(v-if="onPermissions({item}) && item.role === 3") 
                                user-select(:item="item" field="group")
                            template(v-else)
                                span {{ GROUPS.find(r => { return r.value === item.group }).name }}       
                        
                        td.text-sm.font-thin.border.border-gray-300.text-center.w-100
                            change-status(:item="item" :isActive="permissionsInit({item})")
                        td.text-xs.font-thin.border.border-gray-300.text-center.w-150.p-2 {{ item.created_at | moment("D MMMM YYYY") }}
                        
                        td.text-sm.font-thin.border.border-gray-300.text-center.text-gray-500.w-100
                            template(v-if="onPermissions({item})")
                                delete-item(:item="item" :context="{ name_space: 'users', action: 'DeleteUser' }")

        template(v-if="totalPages > 1")
            pagination(
                :totalPages="totalPages"
                :perPage="perPage"
                :currentPage="currentPage"
                @pagechanged="onPageChange"
            )
</template>

<script>
//Components
import TableHeader from '@/components/common/tables/table-header';
import UserImage from '@/components/common/user/user-image';
import UserField from '@/components/common/user/user-field';
import ChangeStatus from '@/components/common/status';
import DeleteItem from '@/components/common/delete';
import UserSelect from '@/components/common/user/user-select';
import Pagination from '@/components/common/pagination';
//Store
import { UsersNameSpace, UsersActionTypes, UsersGetterTypes, UsersMutationTypes } from '@/store/users/types';
import { AuthorizationNameSpace, AuthorizationGetterTypes } from '@/store/authorization/types';
//libs
import moment from 'moment';
//Configs
import { USERS_LIST_TABLE_HEADERS, BUTTONS_VALUES, FORMS_LABELS } from '@/configs/views';
import { ICONS } from '@/configs/icons';
import { USER_ROLES } from '@/configs/user-roles';
import { USER_GROUPS } from '@/configs/user-groups';
//Mixins
import { deleteConfirmation } from '@/mixins/modals';

export default {
    name: "UsersComponent",
    mixins: [deleteConfirmation],
    components: {
        'table-header': TableHeader,
        'user-image': UserImage,
        'user-field': UserField,
        'change-status': ChangeStatus,
        'delete-item': DeleteItem,
        'user-select': UserSelect,
        'pagination': Pagination,
    },
    props: {
        filters: {
            type: Object,
            default: () => ({}),
        },
        search: {
            type: String,
        },
    },
    data() {
        return {
            currentPage: 1,
            perPage: 50,
            totalPages: 0,
        }
    },
    computed: {
        ICONS() {
            return ICONS
        },
        BUTTONS_VALUES() {
            return BUTTONS_VALUES
        },
        FORMS_LABELS() {
            return FORMS_LABELS
        },
        USERS_LIST_TABLE_HEADERS() {
            return USERS_LIST_TABLE_HEADERS
        },
        users() {
            return this.$store.getters[`${UsersNameSpace}/${UsersGetterTypes.GetUsers}`]
        },
        user_id() {
            return this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetId}`]
        },
        user_group() {
            return this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetGroup}`]
        },      
        user_role() {
            return this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetRole}`]
        },
        ROLES() {
            return USER_ROLES
        },
        GROUPS() {
            return USER_GROUPS
        },
    },
    methods: {
        moment() {
            return moment()
        },
        rowNumber(index) {
            return (this.currentPage - 1) * this.perPage + index + 1
        },
        setPages(payload) {
            if (!payload) {
                this.totalPages = 0
                return
            }
            const total = payload.query_total != null ? payload.query_total : payload.total
            const perPage = Number(payload.per_page) || this.perPage
            this.totalPages = Math.ceil((Number(total) || 0) / perPage)
        },
        async onLoad({ per_page, page, filters }) {
            const result = await this.$store.dispatch(`${UsersNameSpace}/${UsersActionTypes.GetUsers}`, {params: { per_page, page: page - 1, ...filters }})
            this.setPages(result && result.data && result.data.data)
        },
        onPageChange(page) {
            this.currentPage = page
            this.reload()
        },
        async onSearch({ search, params }) {
            const result = await this.$store.dispatch(`${UsersNameSpace}/${UsersActionTypes.FindUser}`, { search, params })
            this.setPages(result && result.data && result.data.data)
        },
        reload() {
            if (String(this.search || '').trim()) {
                return this.onSearch({
                    search: this.search,
                    params: { ...this.filters, page: this.currentPage - 1, per_page: this.perPage },
                })
            }
            return this.onLoad({ per_page: this.perPage, page: this.currentPage, filters: this.filters })
        },
        onPermissions({ item }) {
            if (item._id !== this.user_id) {
                if (this.user_role === 1 && this.user_group === 1 ) {
                    if (!(item.role === 1 && item.group === 1)) {
                        return true
                    } else return false                    
                } else if (this.user_role === 2 && this.user_group === 1) {
                    if (item.group !== 1) {
                        return true
                    } else return false
                } else if (this.user_role === 1 && this.user_group === item.group) {
                    if (item.role !== 1) {
                        return true
                    } else return false
                }
            } else return false
        },
        isCurrentUser({item}) {
            if (item._id === this.user_id) return true
            else return false
        },
        permissionsInit({item}) {            
            if (this.isCurrentUser({item})) {
                return true
            } else {
                return this.onPermissions({item})
            }
        }
    },
    async mounted() {
        await this.onLoad({ per_page: this.perPage, page: this.currentPage, filters: this.filters })
    },
    beforeDestroy() {
        this.$store.commit(`${UsersNameSpace}/${UsersMutationTypes.SetEmptyUsers}`)
    },
    watch: {
        filters: {
            async handler() {
                this.currentPage = 1
                await this.reload()
            },
            deep: true,
        },
        search: {
            async handler() {
                this.currentPage = 1
                await this.reload()
            },
        }
    }
}
</script>